import {
  Chip,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import FaceRetouchingOffIcon from '@mui/icons-material/FaceRetouchingOff';

import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { DriverType } from '../../../../interfaces/delivery-company/drivers';
import { useContext } from 'react';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import { UserType } from '../../../../enums/users';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import { CheckCircleIcon } from 'lucide-react';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import React from 'react';
import { CloudOff } from '@mui/icons-material';

interface DriversListingTableProps {
  drivers: DriverType[];
  isLoading: boolean;
}

function DriversListingTable({ drivers, isLoading }: DriversListingTableProps) {
  const [gettingQRCode, setGettingQRCode] = React.useState(false);

  return (
    <TableContainer style={{ maxHeight: '80%' }}>
      {isLoading ? (
        <LinearProgress />
      ) : (
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <b>Name</b>
              </TableCell>
              <TableCell align="center">
                <b>Phone</b>
              </TableCell>

              <TableCell align="center">
                <b>Connected To Whatsapp</b>{' '}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {drivers.map((driver) => (
              <TableRow key={driver.id}>
                <TableCell align="center" style={{ cursor: 'pointer' }}>
                  <a href={`/driver/${driver.id}`}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 3,
                        justifyContent: 'center',
                      }}
                    >
                      <b>{driver.name}</b>

                      {driver.is_deleted && (
                        <PersonOffIcon style={{ color: 'red' }} />
                      )}
                    </div>
                  </a>
                </TableCell>
                <TableCell align="center">{driver.phone_number}</TableCell>

                <TableCell align="center">
                  <div style={{ width: "100%", textAlign: "center" }}>
                    {driver.connected_to_whatsapp ? (
                      <Chip icon={<CheckCircleIcon />} color='success' label='Connected' />
                    ) : (
                      <Chip icon={<CloudOff />} color='error' label='Not Connected' />
                    )
                    }
                    <br /> <br />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
}

export default DriversListingTable;
